import { useCollectiveDemoContext } from 'context/CollectiveDemoContext'
import React, { useCallback, useEffect } from 'react'
import { DemoDescriptionSteps } from './DemoDescriptionSteps'
import { Button, Typography } from 'components/common'
import PanelStepper from 'components/common/PanelStepper'

type IStepsType = {
  label: string
  description?: React.ReactNode
}

const steps: IStepsType[] = [
  {
    label: 'Join the DAO'
    //description: `Once your request to join is accepted, you'll be added to the community and the DAO. Then you can vote on existing proposals, create your own proposals, see the treasury and talk to other members.`
  },
  {
    label: 'Contribute ETH'
    //description:
    //'Once you are member, one of the first things you should do is contribute to DAO to get some voting power.'
  },
  {
    label: 'Create a Proposal'
    //description:
    //'Once you have some tokens, you can also create your own proposals.'
  },
  {
    label: 'Vote on a Proposal'
    // description:
    //   'As a member, you can now Create and Vote on proposals on your own'
  },
  {
    label: `Execute a Proposal as a Signator`
    // description:
    //   'As a member, you can now Create and Vote on proposals on your own'
  },
  {
    label: 'Explore More',
    description: (
      <>
        <Typography size="sm">In a DAO, you can:</Typography>
        <div className="mt-1">
          <Typography color="gray" size="sm">
            &#8226; Create and vote on proposals
          </Typography>

          <Typography color="gray" size="sm">
            &#8226; View the DAO wallet’s assets, history, & estimated value
          </Typography>

          <Typography color="gray" size="sm">
            &#8226; Chat with members
          </Typography>
        </div>
      </>
    )
  },
  {
    label: 'Start Your DAO',
    description: (
      <Typography color="gray" size="sm" fontWeight="light">
        You can restart the demo or go back through any steps.
        <br />
        <br />
        Reach out to help@upstreamapp.com with any questions.
        <br />
        <br />
        When you’re ready, we’re excited to help you start your DAO.
      </Typography>
    )
  }
]

const DemoStepper: React.FC<{ atEndDo: Callback }> = ({ atEndDo }) => {
  const { setCurrentStep, currentStep, setTotalStepsCount } =
    useCollectiveDemoContext()

  const handleNext = useCallback(() => {
    setCurrentStep(currentStep + 1)
  }, [currentStep, setCurrentStep])

  // const handleBack = useCallback(() => {
  //   setActiveStep(prevActiveStep => prevActiveStep - 1)
  // }, [])

  useEffect(() => {
    setTotalStepsCount(steps.length)
  }, [setTotalStepsCount])

  const atEndFn = useCallback(() => {
    window.analytics.track('DAO Demo End Clicked')
    if (atEndDo) {
      atEndDo()
    }
  }, [atEndDo])

  return (
    <div className="p-4 ml-2 mr-4 border border-gray-300 rounded-lg mt-2">
      <Typography color="gray">Demo Steps</Typography>

      <PanelStepper currentStep={currentStep} vertical steps={steps}>
        <DemoDescriptionSteps goNextStep={handleNext} />
        {currentStep === steps.length - 1 && (
          <div className="my-2 flex gap-3">
            <Button onClick={atEndFn} size="sm" color="blue">
              Launch Your DAO
            </Button>
          </div>
        )}
      </PanelStepper>
    </div>
  )
}

export default DemoStepper
